import React from "react";
import { PuffLoader } from "react-spinners";
import { useUserTheme } from "../hooks/useUserTheme";
import { useLocation } from "react-router-dom";
import { useUser } from "../context/UserContext";

interface LoadingScreenProps {
  message?: string;
  color?: string;
  size?: number;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ size = 100, color = "#EAEFDC", message = "Please wait, Loading..." }) => {
  const { fontClass, bgClass } = useUserTheme();
  const { user } = useUser()
  const location = useLocation();
  const formatted = location.pathname
    .split("/")
    .filter(Boolean)
    .filter((s) => s.length < 20)
    .filter((s) => s.toLowerCase() !== "v2")
    .pop() // Get only the last segment
    ?.replace(/[_-]/g, " ")
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ") || "";


  console.log("formatted", formatted);


  const messages = user?.businessType === "Grocery" ? `Please wait while ${formatted} is loading...` : message;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-950/35 backdrop-blur-sm">
      <div className="relative">
        <div className="flex justify-center">
          <PuffLoader color={color} size={size} speedMultiplier={1} />
        </div>
        {/* <h2 className={`mt-6 text-center text-xl font-bold text-slate-800 ${fontClass}`}>Loading...</h2> */}
        <p className={`mt-2 text-center text-base font-bold leading-6 ${fontClass}`}>{messages}</p>
        {/* Animated Dots */}
        <div className="mt-6 flex justify-center gap-2">
          <span className={`h-2.5 w-2.5 animate-bounce rounded-full ${bgClass} [animation-delay:-0.3s]`} />
          <span className={`h-2.5 w-2.5 animate-bounce rounded-full ${bgClass} [animation-delay:-0.15s]`} />
          <span className={`h-2.5 w-2.5 animate-bounce rounded-full ${bgClass}`} />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;